.d6{outline:none;}